import { ReviewItemList } from "./ReviewItemList";

export default ReviewItemList;